import { Controller, FetchOptions, Result } from 'bernie-core';
import { ZendeskLogoutExecutor } from '../../components';
import { withSecurity } from '../../components/auth';

export class ZendeskLogoutController implements Controller {
  public routeName = 'zendesklogout';
  public pageId = 'pages.zendesklogout';
  public path = '/affiliate-hub/zendesk/logout';
  public exact = true;
  public bundles = [];
  public deferTo = ZendeskLogoutExecutor;

  public component = withSecurity(this.deferTo, this.path, false);

  // tslint:disable-next-line:prefer-function-over-method
  public fetch(options: FetchOptions) {
    return Promise.resolve(Result.ok());
  }

  // tslint:disable-next-line:prefer-function-over-method
  public fetchPageData() {
    return Promise.resolve({ title: 'Affiliate Hub Zendesk Logout' });
  }
}
